import { faArrowDown, faArrowUp, faMoneyBillTransfer } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames';
import { formatDateTimeUA } from 'helpers/formatDate';
import { BALANCE_TRANSACTION_TYPES } from 'constants/balanceTransactionTypes';
import styles from './styles.scss';

const ICON_MAP = {
  [BALANCE_TRANSACTION_TYPES.DEPOSIT]: faArrowDown,
  [BALANCE_TRANSACTION_TYPES.WITHDRAWAL]: faArrowUp,
  payment: faMoneyBillTransfer,
};

const TYPE_CLASSES = {
  [BALANCE_TRANSACTION_TYPES.DEPOSIT]: [styles.deposit],
  [BALANCE_TRANSACTION_TYPES.WITHDRAWAL]: [styles.withdrawal],
  payment: [styles.payment],
};

export const BalanceTransactionCard = ({ record }) => {
  const { type, description, amount, location, operator, createdAt } = record;

  return (
    <li className={cn(styles.item, TYPE_CLASSES[type])}>
      <div className={styles.icon}>
        <FontAwesomeIcon icon={ICON_MAP[type]} />
      </div>

      <div className={styles.details}>
        <div className={styles.description}>{description}</div>
        <div className={styles.meta}>
          <span className={styles.time}>{formatDateTimeUA(createdAt, true)}</span>
          {location?.name && <span className={styles.location}>• {location.name}</span>}
          <span className={styles.operator}>
            • {operator.surname} {operator.name[0]}.
          </span>
        </div>
      </div>

      <div className={styles.amount}>{amount} ₴</div>
    </li>
  );
};
